import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../constants/global-hooks";
import { RootState } from "../../store";

interface RequireAuthProps {
  children: JSX.Element;
}

export const RequireAuth = (props: RequireAuthProps) => {
  const { authenticatedUser } = useAppSelector(
    (state: RootState) => state.session
  );

  if (authenticatedUser === null || authenticatedUser === undefined) {
    if (window.location.pathname === "/") {
      return <Navigate to={"/campaign"} />;
    }
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(window.location.pathname)}`}
      />
    );
  }
  return props.children;
};
